var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('input',{attrs:{"type":"file"},on:{"change":_vm.onChangeFile}}),_c('br'),_c('br'),_c('button',{on:{"click":_vm.handleSendFile}},[_vm._v("send file")])])}
var staticRenderFns = []

export { render, staticRenderFns }